import { render, staticRenderFns } from "./ActualizacionForm.vue?vue&type=template&id=11bd540d&"
import script from "./ActualizacionForm.vue?vue&type=script&lang=js&"
export * from "./ActualizacionForm.vue?vue&type=script&lang=js&"
import style0 from "./ActualizacionForm.vue?vue&type=style&index=0&id=11bd540d&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports